import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sign-up-form" }
const _hoisted_2 = { class: "body-text text-align-center registration-warning" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Have an account already? ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "heading h1 text-align-center page-title" }, "Sign up to Augmentify", -1)
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "body-text-sm text-align-center" }, [
  /*#__PURE__*/_createTextVNode(" By continuing "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple" }, "you agree"),
  /*#__PURE__*/_createTextVNode(" that you have read our Privacy Policy. You also authorize Augmentify to send you emails. ")
], -1)

import { reactive, ref, toRaw } from 'vue'
import { NForm, NFormItem, NInput, NButton, NDivider, NIcon, FormRules, FormItemRule, FormInst } from 'naive-ui'
import { Google as GoogleIcon } from '@vicons/fa'
import { useAuthSignUpStore } from "@/stores/auth/signup.store";
import { loginRules } from "@/ts/formValidationRules";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupForm',
  setup(__props) {

const formRef = ref<FormInst | null>(null)

const formData = reactive({
  email: '',
  password: '',
  password_confirmation: '',
})

const signupRules : FormRules = {
  ... loginRules,
  password_confirmation: [{
    required: true,
    validator (rule: FormItemRule, value: string) {
      if (!value) {
        return new Error('Password confirmation is required')
      } else if (value !== formData.password) {
        return new Error('Password confirmation is not the same as password')
      }

      return true
    },
    trigger: ['input', 'blur']
  }]
}

const authSignUpStore = useAuthSignUpStore()

const submitLogin = () => {
  formRef.value?.validate((errors) => {
    if (!errors) {
      authSignUpStore.signUp(toRaw(formData))
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "simple-link",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Log In")
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(NForm), {
          ref_key: "formRef",
          ref: formRef,
          class: "input-group",
          inline: "",
          model: formData,
          rules: signupRules
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NFormItem), { path: "email" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formData.email,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.email) = $event)),
                  size: "large",
                  round: "",
                  placeholder: "Yourname@email.com",
                  class: "form-input"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), { path: "password" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formData.password,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.password) = $event)),
                  type: "password",
                  "show-password-on": "click",
                  size: "large",
                  round: "",
                  placeholder: "Create a password",
                  class: "form-input"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), { path: "password_confirmation" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formData.password_confirmation,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.password_confirmation) = $event)),
                  type: "password",
                  "show-password-on": "click",
                  size: "large",
                  round: "",
                  placeholder: "Confirm password",
                  class: "form-input"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NButton), {
                  class: "button",
                  size: "large",
                  "attr-type": "button",
                  onClick: submitLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SIGN UP ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _hoisted_7
      ])
    ])
  ]))
}
}

})